import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Sale {
  name: string;
  location: string;
  price: number;
}
export function SalesNotification() {
  const [currentSale, setCurrentSale] = useState<Sale | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const indexRef = useRef(0);
  const sales: Sale[] = [{
    name: 'Sarah',
    location: 'Miami, FL',
    price: 28.99
  }, {
    name: 'Michael',
    location: 'Los Angeles, CA',
    price: 28.99
  }, {
    name: 'Jessica',
    location: 'New York, NY',
    price: 28.99
  }, {
    name: 'David',
    location: 'Houston, TX',
    price: 28.99
  }, {
    name: 'Emily',
    location: 'Phoenix, AZ',
    price: 28.99
  }, {
    name: 'Daniel',
    location: 'Chicago, IL',
    price: 28.99
  }, {
    name: 'Ashley',
    location: 'Seattle, WA',
    price: 28.99
  }, {
    name: 'Christopher',
    location: 'Boston, MA',
    price: 28.99
  }, {
    name: 'Amanda',
    location: 'Denver, CO',
    price: 28.99
  }, {
    name: 'Matthew',
    location: 'Atlanta, GA',
    price: 28.99
  }, {
    name: 'Jennifer',
    location: 'Portland, OR',
    price: 28.99
  }, {
    name: 'Joshua',
    location: 'Austin, TX',
    price: 28.99
  }];
  const delaySequence = [4000, 10000, 18000, 14000, 10000, 4000, 13000, 10000];
  useEffect(() => {
    function showNotification() {
      const randomSale = sales[Math.floor(Math.random() * sales.length)];
      setCurrentSale(randomSale);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    }
    function triggerSaleNotification() {
      showNotification();
      const delay = delaySequence[indexRef.current];
      indexRef.current = (indexRef.current + 1) % delaySequence.length;
      setTimeout(triggerSaleNotification, delay);
    }
    triggerSaleNotification();
  }, []);
  return <AnimatePresence data-id="element-235">
      {isVisible && currentSale && <motion.div initial={{
      opacity: 0,
      y: 100,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 100,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed bottom-6 left-4 right-4 md:left-6 md:right-auto md:max-w-sm z-50" data-id="element-236">
          <motion.div initial={{
        y: 10
      }} animate={{
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="bg-[#0C0A09]/95 backdrop-blur-xl rounded-2xl shadow-2xl p-4 flex items-center gap-3 border border-[#CFA86A]/30" style={{
        boxShadow: '0 10px 40px rgba(207, 168, 106, 0.2)'
      }} data-id="element-237">
            {/* Product Image */}
            <div className="flex-shrink-0" data-id="element-238">
              <img src="https://cdn.magicpatterns.com/uploads/ijjTYGfFS1MmmQdLLPGFhC/ChatGPT_Image_Dec_4,_2025,_12_32_32_AM.png" alt="Product" className="w-20 h-20 rounded-lg object-cover border border-[#CFA86A]/20" data-id="element-239" />
            </div>

            {/* Sale Info */}
            <div className="flex-1 min-w-0" data-id="element-240">
              <p className="text-sm font-semibold text-[#F7F5F2] truncate" data-id="element-241">
                {currentSale.name} from {currentSale.location}
              </p>
              <p className="text-xs text-[#F7F5F2]/70 mt-0.5" data-id="element-242">
                just purchased{' '}
                <span className="font-medium text-[#F7F5F2]" data-id="element-243">
                  Decisiones Que Cambian Tu Vida
                </span>
              </p>
              <p className="text-sm font-bold text-[#CFA86A] mt-1" data-id="element-244">
                ${currentSale.price.toFixed(2)}
              </p>
            </div>

            {/* Pulse indicator */}
            <div className="flex-shrink-0" data-id="element-245">
              <motion.div animate={{
            scale: [1, 1.2, 1],
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="w-2 h-2 rounded-full bg-[#CFA86A]" data-id="element-246" />
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}